import { isPhoneInLandscape } from '../../../../styles'

export default () =>
  ({
    default: {
      header: {
        padding: '40px 48px 8px',
        minHeight: '56px',

        [isPhoneInLandscape]: {
          padding: '48px 32px 8px',
        },
      },
    },
  }) as const
